import { useEffect, useState } from "react";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FormControl, Tab, Grid, Table } from "@/comn/components";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { lpcoEnvs, lpcoUtils } from "@/tz/go/egaz/osci/lpco/comn"; // 시스템 공통 유틸
import { Page, Group, Layout, Button, ExcelUpload } from "@/comn/components";
import {
    useForm,
    useToast,
    useFetch,
    useModal,
    useAuth,
    useStore,
    useGrid,
    usePopup,
    useResource,
    useExcel,
    usePage,
} from "@/comn/hooks";
import {
    BASE,
    URLS,
    APIS,
    SF_APRVAPP_SRCH_COND,
    SG_APRVAPP_LST,
} from "@/tz/go/egaz/osci/lpco/app/service/OsciLpcoAprvService";
import { COMN_URLS } from "../../comn/services/OsciLpcoComnAppService";
import { APP_STAT_PPUP } from "../../comn/APP_STAT_PPUP";

/**
 * LPCO Application List
 * !== LPCO 신청서 목록 ==!
 */
export const OSCI0201001Q = (props: any) => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid, menuId } = usePage({
        auth: [
            "auth_osci0001",
            "auth_osci0002",
            "auth_osci0006",
            "auth_osci0007",
            "auth_osci0008",
            "auth_osci0015",
            "auth_osci0016",
            "auth_osci0017",
            "auth_osci0009",
        ],
    });
    const { t } = useTranslation(); // Translation Hook !== 언어 변화 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const auth: any = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!

    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "OSC0121" }, // Application State Code !== 신청서_상태_코드 ==!
        ],
    });

    const location = useLocation();
    let errmsg: any;

    // Application LIST
    const [appCdNoList, setAppCdNoList] = useState([]);

    useEffect(() => {
        grid.appLst.setShow("column", "asnmtOfcrNm", true);
        handler.setInit();
    }, []);

    useEffect(() => {
        handler.setInit();
    }, [location.pathname]);

    /*
     * Approval Application Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Approval Application list search conditions !== 심사 신청서 목록 검색 조건 ==!
        newAppSrchCond: useForm({
            defaultSchema: SF_APRVAPP_SRCH_COND,
            defaultValues: {
                ...(pgeStore?.form || {
                    srchSbmsDtStart: comnUtils.getDate({ m: -1 }),
                    srchSbmsDtEnd: comnUtils.getDate(),
                }),
            },
        }),
    };

    /*
     * Approval Application List Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Approval Application List !== 심사 신청서 목록  ==!
        appLst: useGrid({
            defaultSchema: SG_APRVAPP_LST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const render = {
        grid_appLst: {
            head: {},
            cell: {
                appNo: (props: any) => {
                    const { binding, rowValues, value } = props;
                    const param = { menuTp: "APP", appId: rowValues.appId };
                    return (
                        <Layout direction="col" gap={1}>
                            <Link
                                to={`${URLS.osci0201002s}/${rowValues.appId}`}
                                state={param}
                            >{`${rowValues.appNo}`}</Link>
                        </Layout>
                    );
                },
                appStatNm: (props: any) => {
                    const { binding, rowValues, value } = props;
                    const param = {
                        appUuid: rowValues.appUuid,
                        orgCd: rowValues.orgCd,
                        appCdNo: rowValues.appCdNo,
                        appTpCd: rowValues.appTpCd,
                        appStatCd: rowValues.appStatCd,
                    };
                    return (
                        <Link
                            to={""}
                            state={param}
                            onClick={() => {
                                modal.openModal({
                                    content: (
                                        <APP_STAT_PPUP
                                            paramData={{
                                                appUuid: rowValues.appUuid,
                                                orgCd: rowValues.orgCd,
                                                appCdNo: rowValues.appCdNo,
                                                appTpCd: rowValues.appTpCd,
                                                appStatCd: rowValues.appStatCd,
                                                /* 서버가 신청 원본에서 신청 유형을 판정한다. 아래 "N" 은 appId 가 없을 때만 쓰인다. */
                                                appId: rowValues.appId,
                                                lpcoAplyTpCd: "N",
                                            }}
                                            callbackFn={(data: any) => {
                                                modal.closeModal();
                                                window.location.reload();
                                            }}
                                        />
                                    ),
                                    size: "sm",
                                    height: 200,
                                });
                            }}
                        >{`${rowValues.appStatNm}`}</Link>
                    );
                },
            },
        },
    };

    const fetch = {
        // Application List !== Application 목록 ==!
        getOrgLpcoList: useFetch({
            api: (data) => {
                return lpcoUtils.getOrgLpcoList(auth.get("orgCd"));
            },
            onSuccess: (data) => {
                setAppCdNoList(data || []);
                // Show Approval No under Assigned Officer when the organization uses an approval number pattern !== 기관이 승인번호 채번 규칙을 쓰면 배정담당자 아래 승인번호 표시 ==!
                if ((data || []).some((item: any) => item.aprvNoPtnCd)) {
                    grid.appLst.setShow("column", "asnmtOfcrNm", false);
                    grid.appLst.setShow("column", "asnmtOfcrAprvNo", true);
                }
            },
            onError: () => {
                modal.openModal({
                    content: "msg.osc.00015",
                });
            },
        }),
        getAppList: useFetch({
            api: (page = grid.appLst.page, srchOrgCd = auth.get("orgCd")) => {
                return APIS.getAppList(
                    { ...form.newAppSrchCond.getValues(), srchOrgCd: srchOrgCd, menuTp: "APP" },
                    page,
                    grid.appLst.size,
                );
            },
            enabled: comnUtils.isEmpty(form.newAppSrchCond.errors) && form.newAppSrchCond.isSubmitted,
            key: [grid.appLst.page, grid.appLst.size],
            onSuccess: (data) => {
                setStore(pgeUid, {
                    form: form.newAppSrchCond.getValues(),
                    srchOrgCd: auth.get("orgCd"),
                    menuTp: "APP",
                    page: grid.appLst.page,
                    size: data.appList.page.totalSize,
                });
            },
            onError: (error) => {
                errmsg =
                    error.response?.data.errorCode == -1
                        ? "msg.osc.00015"
                        : error.response?.data.errorMessage || "msg.osc.00015";

                modal.openModal({
                    content: errmsg,
                });
            },
            showToast: false,
        }),
        // Change Application Assignment Confirmation Date !== 신청서 배부 확인 일시 변경 ==!
        updateReceived: useFetch({
            api: (appId, appStatCd) => {
                return APIS.updateReceived(appId, appStatCd);
            },
            onSuccess: (data, param) => {
                navigate(URLS.osci0201002s, { state: { menuTp: "APP", appId: param[0] } });
            },
            onError: (err) => {
                modal.openModal({ content: err.response.data.errorMessage });
            },
            showToast: false,
        }),
    };

    const handler = {
        setInit: async () => {
            await fetch.getOrgLpcoList.fetch();
            handler.getAppList();

            grid.appLst.setShow("column", "btnRcve", false);
        },
        // Get list of Consignment Application List !== 위탁수하물 신청서 목록 조회 ==!
        getAppList: (page: number = 0) => {
            form.newAppSrchCond.handleSubmit(async () => {
                grid.appLst.setPage(page);
                await fetch.getAppList.fetch();
            })();
        },
        // Change Application Assignment Confirmation Date !== 신청서 배부 확인 일시 변경 ==!
        updateReceived: async (appId: any, appStatCd: any) => {
            fetch.updateReceived.fetch(appId, appStatCd);
        },
    };

    return (
        <Page
        // id={pgeUid}
        // title={t(pgeTitle)}
        // navigation={{
        //     base: lpcoEnvs.base,
        //     nodes: [...BASE.nodes, { path: "/E", label: pgeTitle }], // !== TODO path 추가구현 필요 ==!
        // }}
        >
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.newAppSrchCond.schema.srchAppNo} />
                            <Group.Control {...form.newAppSrchCond.schema.srchUcrNo} />
                        </Group.Row>

                        <Group.Row>
                            {/* <Group.Control {...form.newAppSrchCond.schema.srchTin} /> */}
                            <Group.Control
                                {...form.newAppSrchCond.schema.srchAppCdNo}
                                options={appCdNoList}
                                controlSize={10}
                            />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control
                                {...form.newAppSrchCond.schema.srchSbmsDt}
                                rangeButton={0}
                                controlSize={10}
                            />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control
                                {...form.newAppSrchCond.schema.srchAprvDt}
                                rangeButton={0}
                                controlSize={10}
                            />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.newAppSrchCond.schema.srchAppStatCd} excludes={["DR", "SP"]} />
                            <Group.Control {...form.newAppSrchCond.schema.srchCstmOfceCd} />
                        </Group.Row>
                    </Group.Section>

                    <Layout direction="row">
                        <Layout.Left>
                            <Button
                                role="reset"
                                onClick={() => {
                                    // form.newAppSrchCond.reset();
                                    form.newAppSrchCond.setValues({
                                        srchAppNo: null,
                                        srchUcrNo: null,
                                        srchAppCdNo: null,
                                        srchSbmsDtStart: comnUtils.getDate({ m: -1 }),
                                        srchSbmsDtEnd: comnUtils.getDate(),
                                        srchAprvDtStart: null,
                                        srchAprvDtEnd: null,
                                        srchAppStatCd: null,
                                    });
                                    handler.getAppList();
                                }}
                            />
                        </Layout.Left>
                        <Layout.Right>
                            <Button
                                role="search"
                                onClick={async () => {
                                    handler.getAppList();
                                }}
                            />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>

            <Group>
                <Group.Body>
                    <Button
                        role="excelDown"
                        onClick={() => {
                            grid.appLst.exportExcel({
                                excelName: "LPCO Application List",
                                sheetName: "LPCO Application List",
                            });
                        }}
                    ></Button>
                    <Group.Section>
                        <Grid {...grid.appLst.grid} data={fetch.getAppList.data?.appList} render={render.grid_appLst} />
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
